import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>Nota del programmatore</h4>
          <p>
            Questo sito è stato fatto da me (Federico Maero), senza lo scopo di vendere effettivamente i prodotti mostrati nel sito.
          </p>
        </div>

        <div className="footer-section">
          <h4>Link Rapidi</h4>
          <ul>
            <li>
              <a href="#home">Home</a>
            </li>
            <li>
              <a href="#products">Prodotti</a>
            </li>
            <li>
              <a href="#contact">Contatti</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Servizio Clienti</h4>
          <p>Email: info@torrepallets.com</p>
          <p>Tel: +39 123 456 7890</p>
          <p>Orari: Lun-Ven 9:00-17:00</p>
        </div>

        <div className="footer-section">
          <h4>Seguici</h4>
          <div className="social-links">
            <a href="#facebook"><img src="./linkedin-logo.png" /></a>
            <a href="#instagram"><img src="./instagram.png" /></a>
            <a href="#linkedin"><img src="./facebook.png" /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 TorrePallets concept by Federico Maero. Tutti i diritti riservati.</p>
      </div>
    </footer>
  );
};

export default Footer;
